import React, { useEffect, useState } from "react";
import { BellRing, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";

export default function NotifyStock({ productId }) {
  const { user } = useAuth();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);

  useEffect(() => {
    api.get(`/products/${productId}/notify-count`).then(({ data }) => setCount(data.count || 0)).catch(() => {});
  }, [productId, done]);

  const waiting = count > 0 && (
    <p data-testid="notify-count" className="mt-2 inline-flex items-center gap-1.5 text-xs font-display font-bold text-[#19324A]/70 bg-white rounded-full px-3 py-1 border border-[#19324A]/10">
      <Users className="w-3.5 h-3.5 text-[#FF6B9D]" /> {count} {count === 1 ? "person is" : "people are"} waiting on this one
    </p>
  );

  const submit = async (addr) => {
    if (!addr || !addr.includes("@")) { toast.error("Please enter a valid email."); return; }
    setLoading(true);
    try {
      await api.post(`/products/${productId}/notify-stock`, { email: addr });
      setDone(true);
      toast.success("We'll email you the moment it's back 🐾");
    } catch { toast.error("Couldn't set up your alert. Please try again."); }
    finally { setLoading(false); }
  };

  if (done) return (
    <div data-testid="notify-stock-done" className="mt-4 rounded-2xl bg-[#7ED957]/15 border border-[#7ED957]/40 px-4 py-3 text-sm font-display font-semibold text-[#19324A]">
      <span className="flex items-center gap-2"><BellRing className="w-4 h-4 text-[#7ED957]" /> You're on the list — we'll email you when it's back!</span>
      {waiting}
    </div>
  );

  return (
    <div className="mt-4 rounded-2xl bg-[#FFF9EE] border border-[#19324A]/10 p-4" data-testid="notify-stock">
      <p className="font-display font-semibold text-sm text-[#19324A] flex items-center gap-2 mb-2">
        <BellRing className="w-4 h-4 text-[#FF6B9D]" /> Sold out — get notified when it's back
      </p>
      {user ? (
        <button onClick={() => submit(user.email)} disabled={loading} data-testid="notify-stock-btn"
          className="btn-primary w-full !py-2.5 disabled:opacity-50">Notify me</button>
      ) : (
        <div className="flex gap-2">
          <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@example.com"
            data-testid="notify-stock-email"
            className="flex-1 min-w-0 rounded-full border border-[#19324A]/15 bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#FFD93D]" />
          <button onClick={() => submit(email)} disabled={loading} data-testid="notify-stock-btn"
            className="btn-primary !py-2.5 disabled:opacity-50 whitespace-nowrap">Notify me</button>
        </div>
      )}
      {waiting}
    </div>
  );
}
